import { ISpinnerProps } from './Spinner.model';
import { SpinnerSpan, SpinnerContainer } from './Spinner.styled';

const Spinner = ({ color, ...props }: ISpinnerProps) => {
	return (
		<SpinnerContainer {...props}>
			<SpinnerSpan color={color} />
		</SpinnerContainer>
	);
};

export { Spinner };
